$(function(){
    const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;

    $('#loginDlPortal a').click(function (e) {
        e.preventDefault();
        let currentElement = $(this);
        let body = $('body');
        let container = $('#container_loginDlPortal');

        body.toggleClass('loginOpen');
        let isOpen = body.hasClass('loginOpen');

        currentElement.attr('aria-expanded', isOpen.toString());

        if (isReduced) {
            container.toggle();
            if (isOpen) $('#barcode').focus();
        } else {
            container.slideToggle(function () {
                if (isOpen) $('#barcode').focus();
            });
        }
    });


    $('#loginform').submit(function(e) {
        e.preventDefault();

        $('#loginform').removeClass('notValid');
        $('.errorDetailMsg').remove();
        $('#barcode').removeAttr('aria-describedby').removeAttr('aria-invalid');

        $('#loginErrorMsgs').html('');
        $('.formrow').removeClass('notValid');

        var data = {
            barcode: $('#barcode').val(),
            ajax: true
        };

        $.post("/scripts/ajaxDlLogin.php", data, function (jsonresult) {
            if (jsonresult.status === 'success') {
                window.location = "/downloads.php?hash="+jsonresult.hash;
            } else {
                $('#barcode')
                    .focus()
                    .attr('aria-describedby', 'barcode-error')
                    .attr('aria-invalid', 'true')
                    .closest('.inputWrapper')
                    .append('<p id="barcode-error" class="errorDetailMsg" role="alert"><strong>Fehler beim Login:</strong><br /> Ungültiger Barcode eingegeben</p>')
                    .closest('#loginform')
                    .addClass('notValid')
            }
        }, "json");
    });
});